<script setup lang="ts">
import useVueformResponseErrors from 'vueform/src/VueformResponseErrors';
import {ref, type Ref} from 'vue';
import type {JText} from 'joomla/joomla.interface';
import type {SelectOption} from '@/interfaces/SelectOption.interface';
import type {FormConfigs} from '@/interfaces/FormConfigs.inteface';

const completed: Ref<boolean> = ref(false)
const jText: JText = Joomla.JText
const config: FormConfigs = Joomla.getOptions('configuration')
const educationLevels: SelectOption[] = config.educationLevels
const regions: SelectOption[] = config.regions
const vacancyId: string = config.vacancyId

function success(): void {
  document.querySelector<HTMLElement>('#lvm-vacancy-success')!.style.display = 'block'
  document.querySelector<HTMLElement>('.vacancy-form .intro')!.style.display = 'none'
  completed.value = true
}
</script>
<template>
  <Vueform
      ref="form"
      v-if="!completed"
      form-key="lvm-simple-vacancy"
      @success="success"
      @response="useVueformResponseErrors as any"
  >
    <TextElement
        name="name"
        rules="required"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_NAME')"
    />
    <TextareaElement
        name="experience_description"
        rules="required"
        :label="jText._('MOD_REACTIVE_FORMS_LVM_VACANCY_EXPERIENCE_DESCRIPTION')"
        :autogrow="true"
    />
    <SelectElement
        name="education_level"
        rules="required"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_EDUCATION_LEVEL')"
        :placeholder="jText._('MOD_REACTIVE_FORMS_LVM_VACANCY_EDUCATION_PLACEHOLDER')"
        :native="false"
        :floating="false"
        :items="educationLevels"
        :columns="{ default: 12, md: 6 }"
    />
    <TextElement
        name="education_description"
        rules="required"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_EDUCATION_DESCRIPTION')"
        :columns="{ default: 12, md: 6 }"
    />
    <TextElement
        name="phone_number"
        rules="required|digits:8"
        input-type="number"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_PHONE_NUMBER')"
        :debounce="1000"
        :add-class="{input: ['phone-number']}"
        :addons="{ before: '+371'}"
        :columns="{ default: 12, md: 5 }"
    />
    <TextElement
        name="email"
        rules="required|email:debounce=1000"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_EMAIL')"
        :columns="{ default: 12, md: 7 }"
    />
    <SelectElement
        name="desired_region"
        rules="required"
        :placeholder="jText._('MOD_REACTIVE_FORMS_LVM_VACANCY_DESIRED_REGION_PLACEHOLDER')"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_DESIRED_REGION')"
        :native="false"
        :floating="false"
        :items="regions"
        :columns="{ default: 12, md: 6 }"
    />
    <TextElement
        name="desired_region_other"
        rules="required"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_DESIRED_REGION_OTHER')"
        :conditions="[['desired_region', '==', 'Cits']]"
        :columns="{ default: 12, md: 6 }"
    />
    <CaptchaElement name="g_recaptcha_response"/>
    <HiddenElement name="id" :default="vacancyId"/>
    <ButtonElement
        name="submit"
        align="center"
        :button-label="jText._('MOD_REACTIVE_FORMS_LVM_VACANCY_BUTTON_LABEL')"
        :submits="true"
        :add-class="{button: ['btn']}"
    />
  </Vueform>
</template>
